import { customerEntryComponent } from './customerEntry.component';

export const customerEntryStateName = 'app.customerEntry';

export const customerEntryState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: customerEntryStateName,
    url: '/customerEntry',
    component: customerEntryComponent.name,
    resolve: {
      isStateAvailable: (featureFlagService) => {
        'ngInject';
        return featureFlagService.featureFlags.customerEntry;
      }
    }
  });
};
